module.exports = __webpack_public_path__ + "static/media/club.a2bbdc8f.svg";